<template>
  <el-select
    ref="product"
    v-model="selectValue"
    filterable
    remote
    reserve-keyword
    placeholder="请输入关键词"
    :remote-method="remoteMethod"
    :loading="loading"
    :disabled="isDisabled"
    style="width:100%;"
    value-key="code"
    @change="change"
  >
    <el-option
      v-for="(item,index) in list"
      :key="index"
      :label="item.name"
      :value="item"
    >
      <span style="float: left;style:inline-block">型号：{{ item.name }}</span>
      <span style="float: right;style:inline-block;margin-left:10px">销售代码：{{ item.code }}</span>
    </el-option>
  </el-select>
</template>
<script type="es6">
import { getAutoProductInfo } from '@/API';
let timer;
export default {
  data () {
    return {
      list: [],
      isDisabled: false,
      selectValue: '',
      loading: false
    };
  },
  props: {
    row: {
      type: Object,
      default () {
        return {};
      }
    },
    form: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  components: {},
  computed: {},
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        if (!this.form.contractType) {
          return this.$message.warning('请选择订单类型');
        }
        if (timer) {
          window.clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.loading = true;
          getAutoProductInfo(query, this.form.contractType, this.form?.asInterDirect).then((res) => {
            let json = res.data;
            this.loading = false;
            if (json.status === '200') {
              this.list = json.data;
            }
          }).catch(() => {
            this.loading = false;
          });
        }, 200);
      }
    },
    change (val) {
      if (this.row) {
        this.$set(this.row, 'productCode', val.code);
        // this.row.productCode = val.code;
        this.row.productName = val.name;
        this.row.materialNumberId = '';
        this.row.materialUnit = '';
        this.row.unit = val.unit;
        this.row.splitType = val.orderSplitType;
        this.row.salesInvoiceName = val.invoiceName;
        this.row.salesProductName = val.salesProductName;
        this.row.powerCordPin = val.powerCordPin;
        this.row.productPropertyName = val.productPropertyName;
        this.row.serviceNature = val.serviceNature;
        this.row.id = null;
        this.row.isHavePowerCord = val.havePowerCord;
        if (val.havePowerCord) {
          this.row.powerCordSpecification = Number(this.row.powerCordPin) === 2
            ? this.form.powerCordSpecification : this.form.threePlugPowerCord;
        } else {
          this.row.powerCordSpecification = '';
        }
        this.$emit('change', { data: val, row: this.row });
      }
    },
    initData () {
      if (this.row.productCode) {
        this.list = [{
          'name': this.row.productName,
          'code': this.row.productCode
        }];
        this.$nextTick(() => {
          this.selectValue = {
            'name': this.row.productName,
            'code': this.row.productCode
          };
        });
      }
      if (this.row.cloudDesktopMatching !== undefined) {
        this.isDisabled = this.row.cloudDesktopMatching;
      }
    }
  },
  mounted () {
    this.initData();
  },
  watch: {
    row (val) {
      if (val.productCode !== this.selectValue.code) {
        this.initData();
      }
    }
  }
};
</script>
